var map = {
	"./email": "7219",
	"./email.vue": "7219",
	"./opsgenie": "839e",
	"./opsgenie.vue": "839e",
	"./pagerduty": "3ead",
	"./pagerduty.vue": "3ead",
	"./slack": "b457",
	"./slack.vue": "b457",
	"./webhook": "27ad",
	"./webhook.vue": "27ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1968";